import React from 'react'
import Icon from '@ant-design/icons'

const BackSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 12 20" fill="currentColor">
    <path d="M11.7879 1.78788L10 0L0 10L10 20L11.7879 18.2121L3.57576 10L11.7879 1.78788Z"/>
  </svg>
)

const BackIcon = props => <Icon component={BackSvg} {...props} />

export default BackIcon